import { render, staticRenderFns } from "./IsRegDialog.vue?vue&type=template&id=524bcc56&scoped=true"
import script from "./IsRegDialog.vue?vue&type=script&lang=js"
export * from "./IsRegDialog.vue?vue&type=script&lang=js"
import style0 from "./IsRegDialog.vue?vue&type=style&index=0&id=524bcc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524bcc56",
  null
  
)

export default component.exports